import * as types from '../types'

const state = {
  crimeTree: [],
  lawCategoryTree: [],
  selectedCrime: {},
  selectedlawCategory: {}
}

const actions = {
  setCrimeTree ({ commit }, value) {
    commit(types.CRIMETREE, value)
  },
  setLawCategoryTree ({ commit }, value) {
    commit(types.LAWCATEGORYTREE, value)
  },
  setSelectedCrime ({ commit }, value) {
    commit(types.SELECTEDCRIME, value)
  },
  setSelectedLawCategory ({ commit }, value) {
    commit(types.SELECTEDLAWCATEGORY, value)
  }
}

const getters = {
  crimeTree: state => state.crimeTree,
  lawCategoryTree: state => state.lawCategoryTree,
  selectedCrime: state => state.selectedCrime,
  selectedlawCategory: state => state.selectedlawCategory
}

const mutations = {
  [types.CRIMETREE] (state, res) {
    state.crimeTree = res
  },
  [types.LAWCATEGORYTREE] (state, res) {
    state.lawCategoryTree = res
  },
  [types.SELECTEDCRIME] (state, res) {
    state.selectedCrime = res
  },
  [types.SELECTEDLAWCATEGORY] (state, res) {
    state.selectedlawCategory = res
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/cloud.js